// Regex to match SSO attribute placeholders like {firstName}
export const SSO_ATTRIBUTE_PLACEHOLDER_REGEX = /\{[^}]+\}/g

// Extract attribute keys from a mapping template
// E.g {firstName}-{lastName} -> [firstName, lastName]
export const extractAttributeKeys = (mappingTemplate: string) => {
  const matches = mappingTemplate.match(SSO_ATTRIBUTE_PLACEHOLDER_REGEX)
  return matches?.map((match) => match.slice(1, -1)) || []
}
